import React, { useState, useEffect } from 'react';
import { Col, Empty, Space, DatePicker, Form, Modal, Select, Tag, Divider, Table, Button, Image, Row } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';

import { useParams, useNavigate } from 'react-router-dom';
import { collection, addDoc, query, where, onSnapshot } from 'firebase/firestore';
import { db, firebase } from '../../firebase';
import { fetchData, sendData, sendDataOherUrl } from '../../httpRequests';
import { getPharmacyId } from '../../components/Shared';
import { async } from '@firebase/util';
import { formatter } from '../../components/utils/utils';

// import { collection, Firestore, onSnapshot, query, where } from '@firebase/firestore';

//comment
export default function OrderDetails() {
	const navigate = useNavigate();
	const [order, setOrder] = useState({});
	const [products, setProducts] = useState([]);
	const [products1, setProducts1] = useState([]);
	const [tableLoading, setTableLoading] = useState(false)


	const [productsStatus, setproductsStatus] = useState([])
	const [Status, setstatus] = useState([])
	const [ShowModal, setShowModal] = useState(false)
	const [selectedOrderDetail, setselectedOrderDetail] = useState()
	const [form] = Form.useForm();
	let { id } = useParams();
	const [curretOrderId, setcurretOrderId] = useState(id)
	const [PHARMACY_LOGGED, setPHARMACY_LOGGED] = useState(localStorage.getItem("PHARMACY_LOGGED"))
	const [orderToPrepareAmount, setorderToPrepareamount] = useState(0)
	const modifiedOrder = {
		modifiedQuantity: 0,
		modifiedTotalOrder: 0.0
	}
	//const [ShowConfirm,setShowConfirm] =useState(false)
	const { confirm } = Modal
	//con
	const [OrderQuantity_And_Total, setOrderQuantity_And_Total] = useState(modifiedOrder)
	const [modifiedQuantity, setmodifiedQuantity] = useState(0)
	const [modifiedTotalOrder, setmodifiedTotalOrder] = useState(0.0)

	//console.log("test", id)
	useEffect(() => {
		getProductOrderStatus()
		if (id !== null) {
			loadOrder();
		}
		return () => {
			setProducts([]);
			setOrder({});
		};
	}, [curretOrderId]);
	const getOrdersToPrepare = () => {
		const url = '/orders/getAllOrdersByPharmacy'
		const data = {
			pharmacy_id: PHARMACY_LOGGED
		}
		sendData(url, data).then((response) => {
			//console.log(response['order'])
			if (response['order'] != undefined && response['order'].length > 0) {
				console.log(true)
				const OrdersToPrepare = response['order'].filter(o => {
					if (o.order_state_id === 1) {

						return o
					}
				})
				if (OrdersToPrepare != undefined && OrdersToPrepare.length > 0) {
					setorderToPrepareamount(OrdersToPrepare.length)
					//console.log(OrdersToPrepare) 

					setcurretOrderId(OrdersToPrepare[0].id)
					//loadOrder()
					//console.log(id,OrdersToPrepare[0].id)
				}
				else {
					setOrder({})
					setorderToPrepareamount(0)
				}

			}
		})
	}
	const getProductOrderStatus = async () => {
		const url = '/orders/getProductOrderStatus'
		fetchData(url).then((response) => {
			//console.log(response)
			const productsStatu = response['ProductStatus']
			//console.log(productsStatus)
			setproductsStatus(productsStatu.map((status) => {
				return {
					label: status.name,
					value: status.id,
				}
			}));
			setstatus(productsStatu)
		}
		)
	}
	const updateProductStatus = (id, status) => {
		const url = '/orders/updateProductStatusInOrderDetail'
		sendData(url, { order_detail_id: id, status: status })
	}
	const handleChange = (id, status) => {
		setselectedOrderDetail(id)
		if (status != Status.find(s => s.code == 'SCHEDULE_DELIVERY'/*hard codear no es bueno, hacer las cosas rapidas y con presion es peor*/).id) {

			updateProductStatus(id, status)
			//console.log(`selected ${status}`, id);
		}
		else {
			setShowModal(true)
		}
	};
	const onFinish = (values) => {
		//console.log('Success:', values.Description);
		updateProductStatus(selectedOrderDetail, Status.find(s => s.code == 'SCHEDULE_DELIVERY'/*hard codear no es bueno, hacer las cosas rapidas y con presion es peor*/).id)
		setShowModal(false)
		form.resetFields();
	};
	const scheduleDelivery = () => {
		updateProductStatus(selectedOrderDetail, Status.find(s => s.code == 'SCHEDULE_DELIVERY'/*hard codear no es bueno, hacer las cosas rapidas y con presion es peor*/).id)
		setShowModal(false)
	}

	const loadOrder = () => {
		const pharmacyId = getPharmacyId();
		if (!pharmacyId) {
			navigate('/login');
			return false;
		}

		setOrder({});
		setProducts([]);
		const url = '/orders/getOrderById';
		const data = {
			order_id: curretOrderId//id
		};
		sendData(url, data).then((response) => {
			//console.log("order", response)
			if (Object.keys(response).length > 0) {
				const order = response['order'];
				const pharmacyId = getPharmacyId();
				if (pharmacyId) {
					if (order.pharmacy_id == pharmacyId) {
						setOrder(order);
						loadOrderDetails(order);
						//console.log(order, 'klk')
					}
				}
			}
		});
	};

	const loadOrderDetails = (order) => {
		setTableLoading(true)
		const url = '/orders/getOrderDetails';
		const data = {
			order_id: curretOrderId//id
		};
		//console.log('call detail')
		sendData(url, data).then((response) => {
			const orderDetails = response['orderdetail'];
			//console.log("order detail", response)
			if (orderDetails != undefined) {
				orderDetails.map((orderDetail) => {
					//	console.log("iteracion order detail", orderDetail)
					loadPharmacyProductsById(order, orderDetail);
				});

			}
		});
		//console.log("is empty?", data)
		setTableLoading(false)
	};

	const loadPharmacyProductsById = (order, orderDetail) => {

		//setOrderQuantity_And_Total({ modifiedQuantity: orderDetail.quantity, modifiedTotalOrder: orderDetail.total_product })
		const url = '/products/getPharmaciesProductByid';
		const data = {
			pharmacy_id: order.pharmacy_id,
			id: orderDetail.pharmacy_product_id
		};
		sendData(url, data).then((response) => {
			const product = response['pharmacyProduct'];
			console.log("detail product", response)
			if (product !== undefined) {

				//console.log("Ojo aqui", OrderQuantity_And_Total)
				//console.log("quantityyyyyy", order.quantity)
				setmodifiedQuantity(orderDetail.quantity)
				setmodifiedTotalOrder(orderDetail.total_product)
				product.order_quantity = orderDetail.quantity;//orderDetail.quantity;
				orderDetail.gift_status_id == 1 ? (product.gift_status = 'Yes') : (product.gift_status = 'No');
				product.gift_from = orderDetail.from;
				product.gift_message = orderDetail.message;
				product.order_total = orderDetail.total_product//orderDetail.total_product;
				product.product_order_status_id = orderDetail.product_order_status_id
				product.order_detail_id = orderDetail.id
				product.fixedQuantity = orderDetail.quantity
				product.fixedOrder_total = orderDetail.total_product
				//product.clientName=order.clientName

				setProducts(
					(prevState) => [...prevState, product]
				);
				setProducts1(
					(prevState) => [...prevState, { ...product }]
				);
				// 
				// console.log("detalle de la cantidad",products)
			}

		});
	};

	useEffect(() => {
		//console.log("detalle de la cantidad", products)
	}, [products])

	useEffect(() => {
		//console.log("use effect", OrderQuantity_And_Total)
	}, [modifiedQuantity, modifiedTotalOrder])

	const lessButton = (data) => {
		setTableLoading(true)
		// setProducts([])
		let thisProducts = [...products]

		let newP = thisProducts.filter(res => {
			return res.product_pharmacy_id == data.product_pharmacy_id
		})

		console.log(products, thisProducts, data.order_quantity)


		newP[0].order_quantity = data.order_quantity - 1
		console.log("price", newP[0].price, newP[0].order_quantity)
		newP[0].order_total = newP[0].order_quantity * newP[0].price
		// setProducts(products1)
		setTimeout(() => {
			setTableLoading(false)
		}, 0.00000001)


	}

	const plusButton = (data) => {
		setTableLoading(true)
		// setProducts([])
		let thisProducts = [...products]

		let newP = thisProducts.filter(res => {
			return res.product_pharmacy_id == data.product_pharmacy_id
		})

		console.log(products, thisProducts, data.order_quantity)


		newP[0].order_quantity = data.order_quantity + 1
		console.log("price", newP[0].price, newP[0].order_quantity)
		newP[0].order_total = newP[0].order_quantity * newP[0].price
		// setProducts(products1)
		setTimeout(() => {
			setTableLoading(false)
		}, 0.00000001)
	}

	const columns = [
		{
			title: '',
			render: ({ product_img }) => (
				<div
					style={{
						width: 40
					}}
				>
					<Image src={product_img} />
				</div>
			),
			key: 'product_img'
		},
		{
			title: 'Name',
			dataIndex: 'product_name',
			key: 'product_name'
		},
		{
			title: 'Price $',
			render: ({ price }) => (formatter.format(price)),
			key: 'price'
		},
		{
			title: 'Quantity',
			render: ({ ...data }) => (
				 <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', margin: 'auto' }}>
					{/* <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', margin: 'auto' }}>
						{((order.order_state_id == 1 && 'Pending') ||
							(order.order_state_id == 2 && 'Processing')) && <Button onClick={() => lessButton(data)}
								style={
									data.order_quantity <= 1 ?
										{
											height: '35px',
											width: '40px',
											backgroundColor: '#ddd',
											color: '#fff',
											borderRadius: 10,
											fontWeight: 'bold',
											fontSize: 16,
											textAlign: 'center',

										}
										: {
											height: '35px',
											width: '40px',
											backgroundColor: '#128780',
											color: '#fff',
											borderRadius: 10,
											fontWeight: 'bold',
											fontSize: 16,
											textAlign: 'center',

										}
								}
								disabled={data.order_quantity <= 1}
							>-</Button>
						}
					</div> */}
					<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '10px' }}>
						<div style={{ margin: 'auto', justifyContent: 'center', alignItems: 'center' }}>
							{data.order_quantity}
						</div>
					</div>
					{/* <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', margin: 'auto' }}>

						{((order.order_state_id == 1 && 'Pending') ||
							(order.order_state_id == 2 && 'Processing')) && <Button onClick={() => plusButton(data)}
								style={
									data.order_quantity == data.fixedQuantity ?
										{
											height: '35px',
											width: '40px',
											backgroundColor: '#ddd',
											color: '#fff',
											borderRadius: 10,
											fontWeight: 'bold',
											fontSize: 16,
											textAlign: 'center',


										}
										: {
											height: '35px',
											width: '40px',
											backgroundColor: '#128780',
											color: '#fff',
											borderRadius: 10,
											fontWeight: 'bold',
											fontSize: 16,

										}
								}
								disabled={data.order_quantity == data.fixedQuantity}
							>+</Button>
						}
						</div>
					*/}
				</div> 


			),
			key: 'order_quantity'
		},
		// {
		// 	title: 'Send as a gift',
		// 	//dataIndex: 'gift_status',
		// 	key: 'gift_status'
		// },
		{
			title: 'From (gift)',
			render: ({ gift_from }) => (
				<span>{gift_from ? gift_from : 'No message set'}</span>
			),
			//dataIndex: 'gift_from',
			key: 'gift_from'
		},
		{
			title: 'Message (gift)',
			render: ({ gift_message }) => (
				<span>{gift_message ? gift_message : 'No message set'}</span>
			),
			//dataIndex: 'gift_message',
			key: 'gift_message'
		},
		{
			title: 'Client',
			//dataIndex: 'clientName',
			render: ({ first_name, last_name }) => (
				<span>{first_name + ' ' + last_name}</span>
			),
			key: 'clientName'
		},
		{
			title: 'phone',
			colSpan: 1,
			render: ({ phone, text }) => (
				<span>{phone.replace(/^(\d{3})(\d{3})(\d{4}).*/, '+1($1)-$2-$3')}</span>
			),
			key: 'phone',

		},
		{
			title: 'Address',
			//dataIndex: 'clientName',
			render: ({ address_1, address_2 }) => (
				<span>{(address_2 ? address_1 + ' | ' + address_2 : address_1)}</span>
			),
			key: 'Address'
		},
		// {
		// 	title: 'Status',
		// 	render: (_, record) => (
		// 		<Select
		// 			style={{
		// 				width: '100%',
		// 			}}
		// 			tagRender={
		// 				<Tag
		// 					color={'volcano'}

		// 					style={{
		// 						marginRight: 3,
		// 					}}
		// 				>
		// 					{productsStatus.find(status => status.value == record.product_order_status_id).label}
		// 				</Tag>
		// 			}
		// 			placeholder="Please select"
		// 			defaultValue={productsStatus.find(status => status.value == record.product_order_status_id).label}
		// 			onChange={(value) => (handleChange(record.order_detail_id, value))}
		// 			options={productsStatus}
		// 		/>
		// 	),
		// 	key: 'billing_status_id'
		// },
		{ title: 'Order total $', render: ({ ...data }) => (<span>{formatter.format(data.order_quantity * data.price)}</span>), key: 'order_total' },
	];

	const orderStatusChange = async (state) => {
		console.log(state)
		const pharmacyId = getPharmacyId();
		if (pharmacyId) {
			const url = '/orders/updateOrderStatus';
			const data = {
				order_id: order.id,
				state: state,
				user_id: pharmacyId
			};

			sendData(url, data).then(() => {
				loadOrder();
				const url2 = '/ronpon/sendToRonpon';
				const url3 = '/placeToPay/reversepayment'
				const data2 = {
					order_id: order.id,
				}
				if (state == 3) {
					console.log("send to ronpon", order.id,)
					sendData(url2, data2)
				}
				else if (state === 6){
					console.log("send to ronpon reversed", order.id,)
					sendData(url3, data2)
				}
			});

			if (state == 3) {
				const addOrderfirebase = await firebase.firestore().collection('orders')
				addOrderfirebase.add({
					order_id: order.id,
					order_status: state,
					farmacy_id: Number(pharmacyId)
				})
			}
		}




		// const data = {
		// 	pharmacy_id:278,
		// 	user_id: 83,
		// 	state,
		// 	id: order.id,
		// 	driver_id: order.driver_id,
		// 	see: false
		// }
		// console.log(data)

		// const dbRef = await firebase.firestore().collection('NotificationClient');
		// dbRef.add({ ...data });

		let farmacysInFirebase = [];
		const getList = await firebase.firestore().collection('notificationsPush').get()


		getList.forEach(snapHijo => {
			farmacysInFirebase.push({
				idfirebase: snapHijo.id,
				...snapHijo.data()
			})
		})


		let nuewOrder = farmacysInFirebase.filter(e => {
			return e.pharmacy_id == order.pharmacy_id && e.order_id == order.id
		})

		if (nuewOrder.length != 0) {
			const url2 = '/push/send';
			sendData(url2, { ...nuewOrder[0], state }).then((res) => {
				// console.log(res)
			})
		}

		// nuewOrder.filter(E => {
		// 	console.log(E)
		// 	firebase.firestore().doc(`/NotificationClient/${E.idfirebase}`).delete();
		// })
	};

	// const checkAvailableDrivers = () => {
	// 	const pharmacyId = getPharmacyId();
	// 	const url = '/user/getDriverByPharmacy';
	// 	const data = {
	// 		pharmacy_id: pharmacyId
	// 	};
	// 	sendData(url, data).then((response) => {
	// 		if (Object.keys(response).length > 0) {
	// 			const drivers = response['driver'];
	// 			const clientZipCode = order.zip_Code;
	// 			const availableDrivers = [];
	// 			drivers.map((driver) => {
	// 				if (driver.zip_code == clientZipCode) availableDrivers.push(driver);
	// 			});
	// 			if (availableDrivers.length == 0) prepeareOrderToRonPon();
	// 			else addOrderToFirebase();
	// 		}
	// 	});
	// };
	const declineOrder = () => {

		const url = '/placeToPay/checkout/requestId';
		const data = {
			order_id: curretOrderId,
			type: "reverse"
		};
		sendData(url, data).then((res) => console.log("reverse successfuly", res)).catch((res) => console.log(res))
	}
	const checkout = () => {
		const url = '/placeToPay/checkout/requestId';
		const data = {
			order_id: curretOrderId,
		};
		sendData(url, data).then((res) => console.log("checkout successfuly", res)).catch((res) => console.log(res))
	}
	const addOrderToFirebase = () => {
		const dbRef = collection(db, 'orders');
		const fbOrder = {
			driver_id: '',
			order_id: order.id,
			order_status: 3,
			farmacy_id: Number(localStorage.getItem("PHARMACY_LOGGED"))
		};
		addDoc(dbRef, fbOrder);
	};

	// const prepeareOrderToRonPon = () => {
	// 	console.log("prepare order to ronpon")
	// 	const productDetails = products.map((product) => {
	// 		return {
	// 			name: product.product_name,
	// 			price: product.price,
	// 			tax: '0',
	// 			taxes: 0,
	// 			quantity: product.order_quantity,
	// 			imageUrl: (product.product_img && product.product_img) || null
	// 		};
	// 	});
	// 	const url = 'https://ronpon-prisma.vercel.app/api/saveOrderCommerce';
	// 	const data = {
	// 		id: order.id + '',
	// 		commerceKey:
	// 			'c2ca677075cac084882c265114f8c422bee6e9b4b7ecb55cbcc5cd9e477d2fcf2adc375709322d38d274fcc97e49604f1c59075548a15731d9bdf82f6b1569b7',
	// 		products: productDetails,
	// 		user: {
	// 			firstName: 'Hector',
	// 			lastName: 'Lugo',
	// 			phone: order.phone,
	// 			email: 'hlugo@pixnabilab.com'
	// 		},
	// 		address: {
	// 			name: order.alias,
	// 			line1: order.address_1,
	// 			line2: order.address_2,
	// 			zipcode: order.zip_Code,
	// 			city: order.city,
	// 			country: order.ciente_state
	// 		},
	// 		pointA: {
	// 			name: 'Pharmacy Test 01',
	// 			line1: 'Av. Midaie 12',
	// 			line2: '',
	// 			zipcode: '00901',
	// 			city: 'San Juan',
	// 			state: 'Puerto Rico',
	// 			country: 'PR'
	// 		},
	// 		note: '',
	// 		scheduleOption: 'same day',
	// 		subTotal: order.total_order,
	// 		taxes: 0,
	// 		deliveryFee: 6,
	// 		total: order.total_order + 6
	// 	};
	// 	sendDataOherUrl(url, data).catch((error) => {
	// 		console.log('ERROR', error);
	// 	});
	// };
	const showConfirm = () => {
		confirm({
			title: 'Are you sure do you want to decline this order?',
			icon: <ExclamationCircleOutlined />,
			content: "Are you sure do you want to perform this action? It can't be reverse",
			okText: "Decline",
			okButtonProps: { type: 'primary', danger: true },
			cancelButtonProps: {
				style: {
					backgroundColor: '#128780',
					color: '#fff',
				}
			},
			onOk() {
				orderStatusChange(6)
				//declineOrder()
			},

			onCancel() {
				console.log('Cancel');
			}
		});
	};


	return (
		<div>
			<Modal
				centered
				width={800}
				title="Schedule delivery"
				visible={ShowModal}
				onCancel={() => { setShowModal(false) }}
				footer={null}
				closable={true}
			>
				<Form
					layout={"vertical"}
					form={form}
					onFinish={onFinish}

				>
					<Form.Item label="Stimated paid date" name={"stimated_paid_date"}
						rules={[
							{
								required: true,
								message: 'Please input a date!',
							},
						]}>
						<DatePicker style={{ width: '100%' }} />
					</Form.Item >
					<Form.Item >
						<Button
							htmlType="submit"
							style={{
								height: 40,
								color: '#fff',
								borderRadius: 4,
								fontSize: 16,
								width: '100%',
								backgroundColor: '#128780',
								position: 'relative',
								// float: 'right',


								marginRight: 0
							}}
						>Submit</Button>
					</Form.Item>
				</Form>
			</Modal>
			{(Object.keys(order).length > 0 || orderToPrepareAmount > 0) && (
				<>
					<div style={{ textAlign: 'center', marginBottom: 20 }}>
						<h2>Order: #{order.code}</h2>
						<h3>
							Status:{' '}
							{(order.order_state_id == 1 && 'Pending') ||
								(order.order_state_id == 2 && 'Processing') ||
								(order.order_state_id == 3 && 'Ready for pick up by delivery') ||
								(order.order_state_id == 4 && 'On the way') ||
								(order.order_state_id == 5 && 'Delivered') ||
								(order.order_state_id == 6 && 'Rejected') ||
								(order.order_state_id == 7 && 'Ready to be picked up by client')}
						</h3>
					</div>
					<div style={{ justifyContent: 'center' }}>
						{(order.order_state_id < 3 && (
							<Row gutter={24}>
								<Col span={12}>
									<Button
										onClick={() =>
											//prepeareOrderToRonPon()
											orderStatusChange(order.pick_up_status == 1 && order.order_state_id === 2 ? 7 : order.order_state_id + 1)
											//order.pick_up_status == 1?7:order.order_state_id + 1
											//Cada vez que veo el codigo harcodeao de esto tigueres me dan ganas hasta de renunciar

										}
										style={{
											height: 50,
											width: '100%',
											backgroundColor: '#128780',
											color: '#fff',
											borderRadius: 10,
											fontWeight: 'bold',
											fontSize: 16
										}}
									>

										{(order.order_state_id == 1 && 'Accept Order') ||
											(order.order_state_id == 2 && 'Start preparing order')}
									</Button>
								</Col>
								<Col span={12}>
									<Button
										onClick={showConfirm}
										style={{
											height: 50,
											width: '100%',
											// backgroundColor: '#128780',
											color: '#fff',
											borderRadius: 10,
											fontWeight: 'bold',
											fontSize: 16
										}}
										danger
										type="primary"
									>
										Decline
									</Button>
								</Col>
							</Row>

						)) ||
							(order.order_state_id == 3 && (
								<h3>Order is ready to be picked up, notification to carriers has been sent</h3>
							))}
					</div>
					<div style={{ justifyContent: 'center' }}>
						{(order.order_state_id == 7 && (
							<Row gutter={24}>
								<Col span={24}>
									<Button
										onClick={() =>
											//prepeareOrderToRonPon()
											orderStatusChange(5)
											//order.pick_up_status == 1?7:order.order_state_id + 1
											//Cada vez que veo el codigo harcodeao de esto tigueres me dan ganas hasta de renunciar

										}
										style={{
											height: 50,
											width: '100%',
											backgroundColor: '#128780',
											color: '#fff',
											borderRadius: 10,
											fontWeight: 'bold',
											fontSize: 16
										}}
									>

										Picked up by client
									</Button>
								</Col>
								
							</Row>

						)) ||
							(order.order_state_id == 3 && (
								<h3>Order is ready to be picked up, notification to carriers has been sent</h3>
							))}
					</div>
					<Divider />
					{Object.keys(products).length > 0 && (
						<>
							<Space
								direction="vertical"
								size="middle"
								style={{
									display: 'flex',
								}}
							>

								<Table
									columns={columns}
									dataSource={products}
									scroll={{ x: 1300 }}
									rowKey={(item) => item.product_pharmacy_id}

									loading={tableLoading}
								/>

								<Button
									disabled={(order.order_state_id !== 3 || order.order_state_id!==7)}
									ghost={false}
									onClick={() => { getOrdersToPrepare();// console.log(order.order_state_id !== 3 , order.order_state_id!==7) 
									}
										//orderStatusChange((order.pick_up_status == 1 && 7) || order.order_state_id + 1)
									}
									style={(order.order_state_id !== 3 || order.order_state_id!==7) ? {
										height: 50,
										backgroundColor: '#ddd',
										color: '#fff',
										borderRadius: 10,
										fontWeight: 'bold',
										fontSize: 16,
									} : {
										height: 50,
										backgroundColor: '#128780',
										color: '#fff',
										borderRadius: 10,
										fontWeight: 'bold',
										fontSize: 16,

									}}
									block
								>
									Next order
								</Button>
							</Space>
						</>

					)}
				</>
			)}
			{
				(Object.keys(order).length <= 0 && orderToPrepareAmount <= 0) && (
					<>
						<Space
							direction="vertical"
							size="middle"
							style={{
								display: 'flex',
							}}
						>

							<h1>You are up to date!</h1>
							<Empty />
						</Space>
					</>
				)
			}
		</div>
	);
}
